import Vue from 'vue';
import axios from 'axios';
import {hasPermission} from "../../utils/permissions";

// Initial state
const state = {
  events: [],
  event: {},
  totalPages: 0,
  action: '', // Added to resolve undefined state property issue
};

// Getters
const getters = {
  event: (state) => state.event,
  events: (state) => state.events,
  totalPages: (state) => state.totalPages,
};

// Mutations
const mutations = {
  SET_EVENT(state, event) {
    state.event = event;
  },

  SET_EVENTS(state, events) {
    state.events = events;
  },

  SET_ACTION(state, action) {
    state.action = action;
  },

  SET_TOTAL_PAGES(state, totalPages) {
    state.totalPages = totalPages;
  },
};

// Actions
const actions = {
  async getAllEvent({ commit }, [page, search]) {
    if(hasPermission('event')){
      const permission = {
        headers: {
          'X-Permission': 'event',
        },
      };
      const productId = localStorage.getItem('product');
      try {
        const response = await axios.get(
            `/admin/event?page=${page}&product_id=${productId}&search=${search}`,
            permission
        );
        const res = response.data;
        const totalPages = Math.ceil(res.total / res.per_page);
        commit('SET_TOTAL_PAGES', totalPages);
        commit('SET_EVENTS', res.data);
      } catch (error) {
        commit('SET_EVENTS', []);
      }
    }

  },

  async create({}, data) {
    const formData = new FormData();
    formData.append('slug', data.new_slug);
    formData.append('title', data.title);
    formData.append('body', data.body);
    formData.append('caption', data.caption);
    formData.append('meta_title', data.meta_title || '');
    formData.append('meta_description', data.meta_description || '');
    formData.append('meta_keyword', data.meta_keyword || '');
    formData.append('show_in_admin', data.show_in_admin ? 1 : 0);
    formData.append('featured', data.featured ? 1 : 0);
    formData.append('send_email', data.send_email ? 1 : 0);
    formData.append('remove_image', data.remove_image ? 1 : 0);
    formData.append('short_description', data.short_description  || '');
    if(hasPermission('event')){
      const permission = {
        headers: {
          'X-Permission': 'event',
        },
      };

      try {
        const response = await axios.post(
            `/admin/event/create?product_id=${localStorage.getItem('product')}`,
            formData,
            permission
        );
        return response.data;
      } catch (error) {
        console.error('Error creating user guide:', error);
      }
    }
  },

  async update({}, post) {
    const formData = new FormData();
    formData.append('_method', 'PUT');
    formData.append('id', post.id);
    formData.append('slug', post.new_slug);
    formData.append('title', post.title);
    formData.append('body', post.body);
    formData.append('meta_title', post.meta_title || '');
    formData.append('meta_description', post.meta_description || '');
    formData.append('meta_keyword', post.meta_keyword || '');
    formData.append('short_description', post.short_description || '');
    formData.append('show_in_admin', post.show_in_admin ? 1 : 0);
    formData.append('featured', post.featured ? 1 : 0);
    formData.append('send_email', post.send_email ? 1 : 0);
    formData.append('remove_image', post.remove_image ? 1 : 0);
    if (post.caption !== undefined) {
      formData.append('caption', post.caption);
    }
    if(hasPermission('event')){
      const permission = {
        headers: {
          'X-Permission': 'event',
        },
      };

      try {
        const response = await axios.post(
            `/admin/event/update/${post.slug}?product_id=${localStorage.getItem('product')}`,
            formData,
            permission
        );
        return response;
      } catch (error) {
        console.error('Error updating event:', error);
      }
    }
  },

  async view({ commit }, slug) {
    if(hasPermission('event')){
      const permission = {
        headers: {
          'X-Permission': 'event',
        },
      };
      const productId = localStorage.getItem('product');
      try {
        const response = await axios.get(`/admin/event/${slug}/${productId}`, permission);
        commit('SET_EVENT', response.data.data);
      } catch (error) {
        console.error('Error fetching event:', error);
      }
    }
  },

  async delete({}, event) {
    const productId = localStorage.getItem('product');
    try {
      const response = await axios.post(`/admin/event/delete/${event.slug}/${productId}`, {
        '_method': 'DELETE',
      });
      return response.data;
    } catch (error) {
      console.error('Error deleting event:', error);
    }
  },

  async publishing({ commit }, payload) {
    const productId = localStorage.getItem('product');
    try {
      const response = await axios.post(
        `/admin/event/publish/${payload.event.slug}/${payload.action}?product_id=${productId}`
      );
      switch (payload.action) {
        case 'publish':
          payload.event.published = 1;
          payload.event.published_at = 'Just now';
          break;
        case 'unpublish':
          payload.event.published = 0;
          payload.event.published_at = '';
          break;
      }
      commit('SET_EVENT', payload.event);
      return response;
    } catch (error) {
      console.error('Error publishing event:', error);
    }
  },
};

// Exporting the Vuex module
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
